import React, { useEffect, useRef } from 'react';
import style from '../../../assets/styles/modalStyle.module.css';
import warningIcon from '../../../assets/images/warningIcon.png';
import closeIcon from '../../../assets/images/closeSvgIcon.svg';
interface ModalData {
  title: string;
  description: string;
  cancelButton: string;
  saveButton: string;
  substitle?: string;
  className?: string;
}

interface MediumModalProps {
  forwardButton: () => void;
  modalData: ModalData;
  modalMedium: boolean;
  closeModalMedium: () => void;
}

const LockModal: React.FC<MediumModalProps> = ({ forwardButton, modalData, modalMedium, closeModalMedium }) => {
  // ___________ forward button calling on save and make action accordingly ___________
  const ForwardButton = () => {
    forwardButton();
    closeModalMedium();
  };

  // outside clickable close modal
  const modalRef = useRef<HTMLDivElement>(null);
  const quasi = modalData.className;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleOverlayClick = (event: any) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      closeModalMedium();
    }
  };

  useEffect(() => {
    // Attach the event listener when the component mounts
    document.addEventListener('mousedown', handleOverlayClick);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('mousedown', handleOverlayClick);
    };
  }, [handleOverlayClick]);

  return (
    <>
      {modalMedium ? (
        <div className={`${style.mediumModal} lockModelBreaks ${quasi}`}>
          <div className={`${style.center_div} lockModalCenterDiv`} ref={modalRef}>
            <div className="headerModel">
              <div className="headerText">
                {modalData.substitle && <img className="headerIcon" src={warningIcon} alt="" />}
                <p style={{ marginLeft: modalData.substitle ? 0 : -137 }} className="heaserTitle">
                  {modalData.title}
                </p>
              </div>
              <button
                style={{ cursor: 'pointer', border: 'none', background: 'none', padding: '0px' }}
                onClick={() => closeModalMedium()}
              >
                <img src={closeIcon} alt="closeBtn" />
              </button>
            </div>

            {modalData.substitle && <p className="headerSubtitle">{modalData.substitle}</p>}
            <p style={{ marginTop: modalData.substitle ? 0 : 55 }} className="headerContent">
              {modalData.description}
            </p>

            {/* SAVE BUTTON AND CANCEL BUTTON  */}
            <div className={`${style.saveButton_questionCreation_Modal} modalSaveContainer`}>
              {modalData.cancelButton && (
                <button
                  className={` ${style.cancel} ${style.pointer}`}
                  onClick={() => closeModalMedium()}
                  style={{ cursor: 'pointer', border: 'none', background: 'none', padding: '0px' }}
                >
                  {modalData.cancelButton}
                </button>
              )}
              <div>
                <button className={style.blue_button} onClick={() => ForwardButton()}>
                  {' '}
                  {modalData.saveButton}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default LockModal;
